import { render, staticRenderFns } from "./MagynetInteractionsChart.vue?vue&type=template&id=052aabad&scoped=true&"
import script from "./MagynetInteractionsChart.vue?vue&type=script&lang=js&"
export * from "./MagynetInteractionsChart.vue?vue&type=script&lang=js&"
import style0 from "./MagynetInteractionsChart.vue?vue&type=style&index=0&id=052aabad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052aabad",
  null
  
)

export default component.exports